module.exports = __webpack_public_path__ + "static/media/marker-black.49e68a17.svg";